import { matchPath, useLocation } from "react-router-dom";
import { ROUTES } from "routing/routes";

import { linkToReassign } from "features/teachers/routes/teacher/routes/class/routes/assignments/routes/assignment/routes/reassign/links";
import { linkToAssignmentSpeedyMarking } from "features/teachers/routes/teacher/routes/class/routes/speedy-marking/links";

import { linkToEditClassAssignment } from "../../../routes/teacher/routes/class/routes/edit-assignment/links";

const PATHS_WITHOUT_TEACHER_NAVBAR = [
  ROUTES.TEACHER.ASSIGNMENTS.CREATE.buildPath({}),
  linkToEditClassAssignment(),
  linkToReassign(),
  linkToAssignmentSpeedyMarking().pathname
];

export default function useShouldHideTeacherNavBar() {
  const location = useLocation();
  return PATHS_WITHOUT_TEACHER_NAVBAR.some(
    path =>
      !!matchPath(location.pathname, {
        path
      })
  );
}
